export default function parseDecimal(str) {
  return parseInt(str, 10);
}
